module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-new"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('label', [_vm._v("To:")]), _vm._v(" "), _vm._l((_vm.members), function(member, index) {
    return _c('div', {
      staticClass: "btn-item-added"
    }, [_vm._v("\n      " + _vm._s(member.firstname + ' ' + member.surname) + "\n      "), _c('a', {
      staticClass: "remove",
      on: {
        "click": function($event) {
          _vm.remove(index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticClass: "input-holder"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.keywords),
      expression: "keywords"
    }],
    attrs: {
      "type": "text",
      "autofocus": "true"
    },
    domProps: {
      "value": (_vm.keywords)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.keywords = $event.target.value
      }
    }
  }), _vm._v(" "), _c('ul', {
    class: {
      'input-options': true, 'active': _vm.results.length
    }
  }, _vm._l((_vm.results), function(user) {
    return (user['.key'] !== _vm.$root.user.uid) ? _c('li', {
      staticClass: "input-option",
      on: {
        "click": function($event) {
          _vm.add(user)
        }
      }
    }, [_c('div', {
      staticClass: "image-circle"
    }, [_c('img', {
      attrs: {
        "src": user.profileimg
      }
    })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(user.firstname + ' ' + user.surname))])]) : _vm._e()
  }))])], 2), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "message",
    attrs: {
      "type": "text",
      "placeholder": "Type a message..."
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "keydown": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        $event.preventDefault();
        _vm.send($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a7b0ca6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/new/New.vue
// module id = 713
// module chunks = 1